import {
  HttpBearerConfiguration,
  TokenProvider,
} from "@vviinn/user-managment-client-ts";

export const createBearerAuth = (token: string) => {
  const provider: TokenProvider = {
    getToken: () => {
      return new Promise((resolve) => resolve(token));
    },
  };

  const bearerConf: HttpBearerConfiguration = {
    tokenProvider: provider,
  };

  return {
    bearerAuth: bearerConf,
  };
};
